import { SVGProps } from 'react';

/* eslint max-len: 0 */
export const CheckCircle = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' { ...props }>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM16.7682 9.64018C17.1218 9.21591 17.0645 8.58534 16.6402 8.23178C16.2159 7.87821 15.5853 7.93554 15.2318 8.35982L10.4054 14.0458L8.70711 12.3476C8.31658 11.957 7.68342 11.957 7.29289 12.3476C6.90237 12.7381 6.90237 13.3713 7.29289 13.7618L9.79289 16.2618C9.99267 16.4616 10.2676 16.5659 10.5486 16.5494C10.8296 16.5329 11.0896 16.3973 11.2682 16.1752L16.7682 9.64018Z'
		/>
	</svg>
);
